module.exports = __webpack_public_path__ + "static/media/BlackDownloadIcon.03a909eb.svg";